module.exports = __webpack_public_path__ + "static/media/stickman_run_2.a3c29da3.png";